import DashboardsListSection from 'modules/ai_reports/components/DashboardsListSection'
import DiscoverBanner from 'modules/ai_reports/components/DiscoverBanner'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DashboardsListPage = () => {
  return (
    <ResponsivePage.Body variant="fullscreen">
      <DiscoverBanner />
      <DashboardsListSection />
    </ResponsivePage.Body>
  )
}

export default DashboardsListPage
